export const dummyFaqs = [
  {
    question: "How do I book an excursion activity?",
    description: "Simply select your target destination or activity, select your preferred date, pick the tickets package, and click Book Now to proceed to checkout."
  },
  {
    question: "What types of excursion activities can I book?",
    description: "We offer sightseeing tours, red dunes desert safaris, dhow dinner cruises, luxury yacht charters, theme parks passes, and extreme adventure sports. Browse our activity categories to find the best options."
  },
  {
    question: "Can I cancel or reschedule my excursion booking?",
    description: "Cancellation policies vary by activity. Many excursions offer free cancellation up to 24 hours before the activity starts. Check the terms of your specific package on the details page."
  },
  {
    question: "Do I need to bring any special items for desert safaris?",
    description: "We recommend comfortable loose clothing, sunglasses, sunscreen, and sandals. We provide a buffet dinner, refreshments, and sandboarding gear at the desert camp."
  },
  {
    question: "Are group discounts available for activities?",
    description: "Yes, group bookings may be eligible for custom discounts. Please contact our support team with your details to receive a customized quote."
  }
];  